import Api from "@/repository/api";

import { IProductsCategoryTypesRepository } from '@/repository/warehouse/Category/CategoryRepository.types'
import {
    IProductsCategoryTypes,
    ProductsCategoryAddRequestType,
    ProductsCategoryTypesResponse, ProductsCategoryUpdateRequestType
} from '@/entity/warehouse/Products/Category/Category.types';
//import { ResponseDataType } from "@/form/form.types";
//import qs from "qs";
import ProductsCategoryTypes, { ProductsCategory } from '@/entity/warehouse/Products/Category/Category';
import { ResponseDataType } from '@/form/form.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { getResponse } from "@/repository/Helpers/repositoryLib";
import qs from 'qs';


export class ProductsCategoryRepository implements IProductsCategoryTypesRepository {
    async fetchAll(data?: FormData): Promise<IProductsCategoryTypes[]> {
        //const response = await Api.get('/products/category/get');
        const response = await getResponse(`/products/category/get`, data);
        console.log('ProductsCategoryRepository ----')
        const responseData = response.data as ProductsCategoryTypesResponse[];
        return responseData.map((data: ProductsCategoryTypesResponse) => new ProductsCategoryTypes(data));
    }

    async fetchData(data: PaginationRequestType): Promise<IProductsCategoryTypes>{
        const response = await Api.get(`/products/category/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data[0] as ProductsCategoryTypesResponse;
        console.log('Category Response -'+responseData )
        return new ProductsCategory(responseData);
    }
    async create(data: ProductsCategoryAddRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/products/category/create', data)
        return res.data
    }
    async update(data: ProductsCategoryUpdateRequestType) : Promise<ResponseDataType> {
        const res = await Api.post('/products/category/update', data)
        return res.data
    }
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const res = await Api.post(`/products/category/delete`, data);
        return res.data;

    }
}